import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { Applications } from "./applications_tab/Applications"

export function ApplicationsContainer() {
  const { activeTab, handleTabChange: handleChange } =
    useHashTab("applications")

  return (
    <div>
      <MUITab
        tabItems={[{ id: "applications", label: "Applications" }]}
        value={activeTab}
        handleChange={handleChange}
      />

      {activeTab === "applications" && <Applications />}
    </div>
  )
}
